'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
var _MenuItem = require('./MenuItem');
var _MenuItem2 = _interopRequireDefault(_MenuItem);
require('./Menu.css');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * Menu to use in for example a dropdown.
 */
var Menu = function (_Component) {
  _inherits(Menu, _Component);
  function Menu() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, Menu);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      activeIndex: 0
    }, _this.componentDidMount = function () {
      if (_this.props.focusOnOpen) {
        _this.selectIndex(0);
      }
    }, _this.onMouseEnterItem = function (event) {
      var nextIndex = (event.target.attributes['data-index'] || {}).value;
      if (nextIndex) {
        _this.selectIndex(parseInt(nextIndex));
      }
    }, _this.onKeyDown = function (event) {
      switch (event.keyCode) {
        case 38:
          // key up
          _this.selectIndex(_this.state.activeIndex - 1);
          event.preventDefault();
          break;
        case 40:
          // key down
          _this.selectIndex(_this.state.activeIndex + 1);
          event.preventDefault();
          break;
      }
    }, _this.selectIndex = function (index) {
      if (_this.refs['item-' + index]) {
        _this.setState({
          activeIndex: index
        });
        _this.refs['item-' + index].focus();
      }
    }, _this.focus = function () {
      _this.selectIndex(0);
    }, _this.wrapItemEvent = function (existingOnClick) {
      var onSelect = _this.props.onSelect;
      if (onSelect) {
        if (existingOnClick) {
          return function (event) {
            onSelect(event);
            existingOnClick(event);
          };
        } else {
          return null;
        }
      } else {
        return existingOnClick;
      }
    }, _this.render = function () {
      var children = _this.props.children;
      var onMouseEnter = _this.onMouseEnterItem;
      var wrapItemEvent = _this.wrapItemEvent;
      var index = 0;
      var newChildren = _react2.default.Children.map(children, function (child) {
        if (child.props && (child.props.href || child.props.onClick || child.props.onChange)) {
          return _react2.default.cloneElement(child, {
            onMouseEnter: onMouseEnter,
            'data-index': index,
            onClick: wrapItemEvent(child.props.onClick),
            onChange: wrapItemEvent(child.props.onChange),
            ref: 'item-' + index++
          });
        } else {
          return child;
        }
      });
      var classes = (0, _classnames2.default)('c-menu');
      return _react2.default.createElement('div', {
        className: classes,
        onKeyDown: _this.onKeyDown
      }, newChildren);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * Selects the specified index in the menu if the index is available
   *
   * @param index the index to select
   */

  /**
   * Focus this menu.
   */

  return Menu;
}(_react.Component);
Menu.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Determines whether the menu should be focussed when opened */
  focusOnOpen: _propTypes2.default.bool,
  /** Fires when an item is selected. */
  onSelect: _propTypes2.default.func,
  /** Content to display within the menu. See also MenuItem or MenuDivider */
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired
} : {};
exports.default = Menu;